import { render, staticRenderFns } from "./SelectLayoutModal.vue?vue&type=template&id=5a2cd36c"
import script from "./SelectLayoutModal.vue?vue&type=script&lang=js"
export * from "./SelectLayoutModal.vue?vue&type=script&lang=js"
import style0 from "./SelectLayoutModal.vue?vue&type=style&index=0&id=5a2cd36c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports